import React from "react";
import { Box, Typography, Link, makeStyles } from "@material-ui/core";
import { connect } from "react-redux";
import { getSystemLabel } from "src/constant/Messages";

const useStyles = makeStyles((theme) => ({
  flevtintend: {
    paddingLeft: theme.spacing(3),
  },
  secondol: {
    paddingLeft: theme.spacing(2),
    " & li::marker": {
      content: "attr(point-attr)",
    },
    " & li": {
      paddingLeft: "0.3em",
    },
  },
}));
const CookiesPolicy = ({ globalData }) => {
  const classes = useStyles();

  return (
    <Box alignItems="center" display="block">
      <Typography variant="h2" component="h2" paragraph>
        Szanujemy Państwa prawo do prywatności
      </Typography>
      <Typography paragraph>
        Instytucja Zarządzająca{" "}
        {getSystemLabel("programYm", globalData.systemInfo)} (IZ{" "}
        {getSystemLabel("programShortcut", globalData.systemInfo)}) informuje,
        iż wszelkie dane użytkowników uzyskane za pośrednictwem niniejszego
        serwisu internetowego przeznaczone są wyłącznie na użytek Urzędu
        Marszałkowskiego Województwa Podlaskiego w Białymstoku.
      </Typography>
      <Typography paragraph>
        Administrator Portalu na podstawie uzyskanych informacji może sporządzać
        zbiorcze zestawienia statystyczne, które mogą być ujawniane osobom
        trzecim. Zestawienia takie nie zawierają jednak żadnych danych
        pozwalających na identyfikację pojedynczych użytkowników.{" "}
      </Typography>
      <Typography paragraph>
        Poufność danych może być uchylona na polecenie odpowiednich organów
        państwowych.
      </Typography>
      <Typography paragraph>
        IZ {getSystemLabel("programShortcut", globalData.systemInfo)} zastrzega
        sobie prawo zmiany powyższej polityki prywatności poprzez opublikowanie
        jej nowej wersji na niniejszej stronie. Zmiany w polityce prywatności
        obowiązują od dnia ich opublikowania.
      </Typography>
      <Typography paragraph>
        Każdego użytkownika serwisu obowiązuje aktualna polityka prywatności,
        której treść znajduje się na niniejszej stronie.
      </Typography>
      <Typography variant="h2" component="h2" paragraph>
        Wykorzystywanie danych
      </Typography>
      <Typography paragraph>
        Dane zbierane w ramach naszego Serwisu służą do zapewnienia określonych
        usług naszym użytkownikom oraz do celów administracyjnych i
        statystycznych, a także do ochrony Serwisu.
      </Typography>
      <Typography variant="h2" component="h2" paragraph>
        Pliki "cookies"
      </Typography>
      <Typography paragraph>
        Możliwe jest <b>blokowanie i usuwanie plików "cookies"</b> przy pomocy
        zmiany ustawień domyślnych przeglądarki. Standardowo oprogramowanie
        służące do przeglądania stron internetowych dopuszcza umieszczanie
        plików „cookies” na urządzeniu końcowym. Ustawienia te mogą zostać
        zmienione w taki sposób, aby blokować automatyczną obsługę plików
        „cookies” w ustawieniach przeglądarki internetowej bądź informować o ich
        każdorazowym przesłaniu na urządzenie użytkownika. Szczegółowe
        informacje o możliwości i sposobach obsługi plików „cookies” dostępne są
        w ustawieniach oprogramowania (przeglądarki internetowej).
      </Typography>
      <Typography paragraph>
        W przeglądarce Mozilla Firefox - menu "Narzędzia" wybierz "Opcje" i w
        nich zakładkę "Prywatność". Przeglądarka daje Ci możliwość zaznaczenia,
        że nie chcesz być śledzony w ogóle albo usunięcia pojedynczych
        "ciasteczek" poszczególnych witryn.{" "}
      </Typography>
      <Typography paragraph>
        W przeglądarce Google Chrome - menu ukrytym pod trzema poziomymi
        kreskami w prawym górnym rogu przeglądarki wybierz "Narzędzia", a potem
        "Wyczyść dane przeglądania...". Oprócz możliwości czyszczenia plików
        "cookies", znajduje się tam link "Więcej informacji", który prowadzi do
        szczegółowego opisu funkcji prywatności przeglądarki.{" "}
      </Typography>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  globalData: state.globalData,
});

export default connect(mapStateToProps, null)(CookiesPolicy);
